import axios from 'axios'
import { CommonFilterModel, CommonParams } from '@/api/resources/common/shared/models/common.models'
import { ConfigurationAssaygroupLaboratoryCreateRequest, ConfigurationAssaygroupLaboratoryPatchInBatchRequest, ConfigurationAssaygroupLaboratoryResponse } from '@/modules/configurationModule/detail/local-assays/assaygroups-laboratory/services/configuration-assaygroup-laboratory/configuration-assaygroup-laboratory.dto'
import { IResponseAgGrid } from '@/shared/models/ag-grid.model'
import { EntityIdentifiersRequest, EntityIdentifierWithErrorResponse } from '@/shared/models/http/http.model'

class ConfigurationAssaygroupLaboratoryService {
    async create(laboratoryId: number, request: ConfigurationAssaygroupLaboratoryCreateRequest): Promise<ConfigurationAssaygroupLaboratoryResponse> {
        const response = await axios.post<ConfigurationAssaygroupLaboratoryResponse>(`/configuration/laboratories/${laboratoryId}/assaygroupLaboratories`, request)
        return response.data
    }

    async paginator(filterModel: CommonFilterModel | undefined, params: CommonParams | undefined, laboratoryId: number): Promise<IResponseAgGrid<ConfigurationAssaygroupLaboratoryResponse>> {
        const response = await axios.put<IResponseAgGrid<ConfigurationAssaygroupLaboratoryResponse>>(`/configuration/laboratories/${laboratoryId}/assaygroupLaboratories`, { ...filterModel }, { params })
        return response.data
    }

    async get(assaygroupLaboratoryId: number, laboratoryId: number): Promise<ConfigurationAssaygroupLaboratoryResponse> {
        const response = await axios.get<ConfigurationAssaygroupLaboratoryResponse>(`/configuration/laboratories/${laboratoryId}/assaygroupLaboratories/${assaygroupLaboratoryId}`)
        return response.data
    }

    async delete(laboratoryId: number, request: EntityIdentifiersRequest): Promise<EntityIdentifierWithErrorResponse[]> {
        const response = await axios.delete<EntityIdentifierWithErrorResponse[]>(`/configuration/laboratories/${laboratoryId}/assaygroupLaboratories/batch`, { data: request })
        return response.data
    }

    async patch(laboratoryId: number, request: ConfigurationAssaygroupLaboratoryPatchInBatchRequest[]): Promise<EntityIdentifierWithErrorResponse[]> {
        const response = await axios.patch<EntityIdentifierWithErrorResponse[]>(`/configuration/laboratories/${laboratoryId}/assaygroupLaboratories/batch`, request)
        return response.data
    }
}

export const configurationAssaygroupLaboratoryService = new ConfigurationAssaygroupLaboratoryService()
